import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.newsletter.Delete;
const ListEndpoint = ApiEndpoints.newsletter.List;
const EditPath = "edit-newsletter";
const tableHeader = ["Date", "Title", "slug"];
const tbody = ["createdAt", "title", "slug"];

export default function NewsletterPage() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.newsletters;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (newsletter_id) => {
    const payload = { newsletter_id };
    try {
      const response = await ApiRequest("POST", DeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Newsletter Management',
    user: 'Admin',
    innerpage: 'Newsletter Management / Newsletters'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-newsletter">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
